export default __webpack_public_path__ + "static/media/a037-biometricData-10.2394085b.png";